import { call, put, takeEvery } from 'redux-saga/effects'
import * as notificationActions from '@redux/ducks/common/notification.Ducks'
import * as notificationApi from '@apis/common/notification.Api'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListNotification({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof notificationApi.getListNotification> = yield call(notificationApi.getListNotification, queryString)
    yield put(notificationActions.getListNotificationSuccess(res))
  } catch (error) {
    yield put(notificationActions.getListNotificationFail(error))
  }
}

export default function* watchNotification() {
  yield takeEvery(notificationActions.getListNotification.toString(), fetchListNotification)
}

